const KEY_VIOLATION_ACTION_TYPE = {
    NONE: -1,
    LOG: 0,
    ESCAPE: 1,
    DO_NOT_TRACK: 2,
};

module.exports = {
    KEY_VIOLATION_ACTION_TYPE
};